export const darkBlue = '#001f3b';
export const blackish = '#02060a';
export const lightBlue = '#87c7f7';
export const lighterBlue = '#b9e0f7';
export const gold = '#d9a700';
export const scollbarTrack = 'rgba(185, 224, 247, 0.6)';
